import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import { EMPTY, Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { JobService } from './job-service/job.service';
import { JobStatusModel } from './job-service/models/job-status-model';

@Injectable({
  providedIn: 'root'
})
export class JobStatusResolver implements Resolve<JobStatusModel> {

  constructor(private service: JobService, private router: Router) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<JobStatusModel> {
    let jobId: string = route.params['jobId'];
    jobId = jobId !== undefined ? jobId : route.parent.params['jobId'];

    return this.service.getJobStatus(+jobId);
  }
}
